import * as React from 'react';
import ResizeObserver from 'rc-resize-observer';
import classNames from 'classnames';
/**
 * Fill component to provided the scroll content real height.
 */
const Filler = React.forwardRef(({ height, offset, children, prefixCls, onInnerResize }, ref) => {
    let outerStyle = {};
    let innerStyle = {
        display: 'flex',
        flexDirection: 'column'
    };
    if (offset !== undefined) {
        outerStyle = { height, position: 'relative', overflow: 'hidden' };
        innerStyle = Object.assign(Object.assign({}, innerStyle), { transform: `translateY(${offset}px)`, position: 'absolute', left: 0, right: 0, top: 0 });
    }
    return (<div style={outerStyle}>
                <ResizeObserver onResize={({ offsetHeight }) => {
            if (offsetHeight && onInnerResize) {
                onInnerResize();
            }
        }}>
                    <div style={innerStyle} className={classNames({
            [`${prefixCls}-holder-inner`]: prefixCls
        })} ref={ref}>
                        {children}
                    </div>
                </ResizeObserver>
            </div>);
});
Filler.displayName = 'Filler';
export default Filler;
